import React from 'react';
import styled from 'styled-components';
import PageHeroSection from '../components/hero-section/PageHeroSection';
import IntelliCubixColoredImage from '../assets/general/intellicubix-colored.png';
import Button from '../components/Button';

const MainContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
`;

const MainContent = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  padding: 50px 15px 15px 15px;
  max-width: 1170px;
  margin: 0 auto;
`

const IntelliCubixColored = styled.img`
  width: 350px;
  height: 59px;
  margin-bottom: 30px;
`;

const MainSection = styled.main`
  width: 100%;

  p {
    font-size: 22px;
    line-height: 1.7;
    font-weight: 400;
    letter-spacing: 1px;
    text-align: justify;
    margin-bottom: 30px;

    span {
      font-weight: 600;
      color: ${(props) => props.theme.colors.magenta};
    }
  }
`;

const About = () => {
  return (
    <MainContainer>
      <PageHeroSection
        pageTitle="About"
      />
      <MainContent>
        <IntelliCubixColored src={IntelliCubixColoredImage} alt="Intellicubix Colored" />
        <MainSection>
          <p>Since our inception in 2010, <span>IntelliCubix</span> has been a beacon of digital excellence, propelling startups and small businesses to stellar heights in the digital cosmos. Our craft extends beyond mere website creation; we weave intricate digital tapestries, melding the finesse of design with the precision of advanced programming. Our domain is the vibrant frontier of data-driven innovation, where Machine Learning isn't just a tool—it's the essence of our creations, illuminating the path to digital enlightenment.</p>
          <p>Our ethos marries imagination with the ingenuity of technology, crafting digital realms that transcend mere functionality. Every solution we offer is a narrative, a digital odyssey tailored to echo the essence of your brand, engineered to strike a chord with your audience. In our universe, we are more than developers—we are the digital craftsmen who lay the foundations for platforms that are not just resilient and scalable, but also visionary, poised to journey through time with your business.</p>
          <p>Envision a realm where app development is not just a process, but an art form, where each pixel and every code breathes life into your unique business vision. Our collective of dreamers and doers, comprised of astute designers and tech savants, is fueled by this vision. We deliver not just sleek, intuitive interfaces but also complex, reliable back-ends, ensuring an immersive, fluid user experience. Our commitment is to the frontier, to elevate your business beyond the horizon of the present, crafting digital legacies that don't just follow trends—they pioneer them.</p>
          <p>Step into our world, where each digital masterpiece we craft is a leap forward, reimagining the future of your business in the digital epoch.</p>
        </MainSection>
      </MainContent>
      <Button text="Let’s craft your success story together" />
    </MainContainer>
  );
};

export default About;

